<div class="tracker" *ngIf="mode && milestoneObj">
  <h3 id="qStatus" color="primary" *ngIf="quotePage">Status: {{current.label}}</h3>
  <div id="qTrackerLine" class="tracker-line">
     <div class="travelled" [style.flex-basis.%]="percent"></div>
     <div class="to-travel" [style.flex-basis.%]="100 - percent"></div>
  </div>

  <div class="tracker-circles">
     <div #trigger *ngFor="let p of positions">

        <div id="qTrackerCirlce" class="tracker-circle" [class.visited]="current.position > p"></div>

        <ng-container *ngIf="current.position === p">
           <button id="qTrackerStatus" mat-button class="tracker-status" color="accent" [style.transform]="transform">
              <mat-icon id="qTrackerIcon" [svgIcon]="current.icon"></mat-icon>
              <span id="qTrackerLabel" class="tracker-label">{{current.label}}</span>
           </button>
        </ng-container>
     </div>
  </div>
</div>
